/* eslint-disable */
// AWS configuration for Vercel deployment
// This replaces aws-exports.js for production deployment

const awsmobile = {
    "aws_project_region": process.env.REACT_APP_AWS_REGION || "us-west-2",
    "aws_appsync_graphqlEndpoint": process.env.REACT_APP_APPSYNC_ENDPOINT || "https://dekovhjsj5dp3px2i5etghrbvu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": process.env.REACT_APP_AWS_REGION || "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": process.env.REACT_APP_APPSYNC_API_KEY || "da2-bbniu6g2i5e2ti5ggdvtxwhcly",
    "aws_cognito_identity_pool_id": process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || "us-west-2:5c36f482-f634-41e7-a003-eea96eeb76a9",
    "aws_cognito_region": process.env.REACT_APP_AWS_REGION || "us-west-2",
    "aws_user_pools_id": process.env.REACT_APP_USER_POOL_ID || "us-west-2_owXFa5JeE",
    "aws_user_pools_web_client_id": process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || "7v3oob0saplubpkpr29a23h30l",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": process.env.REACT_APP_S3_BUCKET || "amplify-homegridportal-phoenix-151018-deployment",
    "aws_user_files_s3_bucket_region": process.env.REACT_APP_AWS_REGION || "us-west-2"
};

export default awsmobile;
